


















































import Vue from "vue";
import UserModal from "@/components/UserModal.vue";
import Container from "@/components/Container.vue";
import authService from "@/services/auth.service";

export default Vue.extend({
  components: {
    Container,
    UserModal,
  },
  data() {
    return {
      isAdmin: false,
    };
  },
  created: async function () {
    this.isAdmin = await authService.isAdmin();
  },
});
